import { render } from "./RegisterStudent.vue?vue&type=template&id=4e6fc494"
import script from "./RegisterStudent.vue?vue&type=script&lang=js"
export * from "./RegisterStudent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__